module.exports = __webpack_public_path__ + "img/fat1.cbdef768.png";